import Component from '../abstracts/Component';

export default class DropdownLandingComponent extends Component {

  get COMPONENTNAME() {
    return 'DropdownLandingComponent';
  }

  get SELECTORS() {
    return {
      collapseBoxes: '[data-collapse-box]',
      collapseContent: '[data-collapse-content]',
      collapseTrigger: '[data-collapse-trigger]',
      continentDropdown: '.s-p__continent__dropdown',
      continentContent: '.s-p__continent__content'
    };
  }

  get ATTRS() {
    return {
      collapseBox: 'data-collapse-box',
      collapseCloseOthers: 'data-collapse-close-others',
      collapseOpened: 'data-collapse-opened',
      collapseTrigger: 'data-collapse-trigger',
      collapseTriggered: 'data-collapse-triggered',
    }
  }

  get CLASSES() {
    return {
      collapsed: 'collapsed',
      opened: 'opened'
    }
  }

  constructor(compEl) {
    super(compEl);
    this.collapseBoxes = this.$component.querySelectorAll(this.SELECTORS.collapseBoxes);
    this.collapseTrigger = this.$component.querySelectorAll(this.SELECTORS.collapseTrigger);
  }

  initCollapse() {
    let ctx = this;
    // add collapsed on collapsable boxes
    if (this.collapseBoxes != null) {
      this.collapseBoxes.forEach(collapse => {
        ctx.setCollapseHeight(collapse);
      });

    }
    // bind click
    if (this.collapseTrigger != null) {
      this.collapseTrigger.forEach((trigger, i) => {
        if (trigger.getAttribute(ctx.ATTRS.collapseTriggered) == null) {
          trigger.addEventListener('click', () => this.handleCollapseTrigger(trigger, i));
          trigger.setAttribute(ctx.ATTRS.collapseTriggered, '');
          if (trigger.getAttribute(ctx.ATTRS.collapseOpened) === 'true') {
            // trigger the open
            trigger.click();
          }
        }
      });
    }
  }

  setCollapseHeight(collapse) {
    if (collapse.getAttribute(this.ATTRS.collapseTriggered) == null) {
      let content = collapse.querySelector(this.SELECTORS.collapseContent);
      let height = content.offsetHeight;
      content.style.maxHeight = `${height}px`;
      collapse.classList.add(this.CLASSES.collapsed);
      collapse.setAttribute(this.ATTRS.collapseTriggered, '');
    }
  }

  handleCollapseTrigger(trigger, i) {
    let ctx = this;
    let target = document.querySelector('[' + this.ATTRS.collapseBox + '="' + trigger.getAttribute(this.ATTRS.collapseTrigger) + '"]');
    if (target != null) {
      if (target.hasAttribute(ctx.ATTRS.collapseCloseOthers)) {
        //closes other country dropdowns
        document.querySelectorAll('.s-p__country [data-collapse-box].opened').forEach(function (country) {
          if (country.getAttribute(ctx.ATTRS.collapseBox) !== trigger.getAttribute(ctx.ATTRS.collapseTrigger)) {
            let parentEl = country.parentElement;
            parentEl.querySelector(ctx.SELECTORS.collapseBoxes).classList.toggle(ctx.CLASSES.collapsed);
            parentEl.querySelector(ctx.SELECTORS.collapseBoxes).classList.toggle(ctx.CLASSES.opened);
            parentEl.querySelector(ctx.SELECTORS.collapseTrigger).classList.toggle(ctx.CLASSES.opened);
          }
        });
      }
      target.classList.toggle(ctx.CLASSES.collapsed);
      target.classList.toggle(ctx.CLASSES.opened);
      trigger.classList.toggle(ctx.CLASSES.opened);

      if (trigger.dataset.collapseBodyclass != null) {
        document.body.classList.toggle(trigger.dataset.collapseBodyclass);
      }
    }
  }

  unbindDropdowns() {
    let ctx = this;
    document.querySelectorAll(this.SELECTORS.continentDropdown).forEach(function (continent) {
      continent.removeAttribute(ctx.ATTRS.collapseTrigger);
    });
    document.querySelectorAll(this.SELECTORS.continentContent).forEach(function (continent) {
      continent.removeAttribute(ctx.ATTRS.collapseBox);
    });

  }

  bindEvents() {
    let ctx = this;
    // update the collapsed content
    document.addEventListener(this.$customEvents.COLLAPSE_EVENTS.update, (e) => {
      let collapseContent = e.payload.extraDiv.closest(ctx.SELECTORS.collapseContent);
      collapseContent.style.maxHeight = 'none';
    });
  }

  render() {
    this.log('Rendering...');
    if (window.matchMedia('(min-width: 1024px)').matches) {
      this.unbindDropdowns();
    }
    this.initCollapse();
    // go events
    this.bindEvents();
  }
}
